module.exports = __webpack_public_path__ + "media/src/img/detail-cloud-right-cc9fe9c63671779cf3c432ed14ba96dc.png";